module.exports = __webpack_public_path__ + "static/media/alertIconSuccess.ac36b05b.svg";